import { createFileRoute, useParams } from '@tanstack/react-router';
import { AuditLogDetailViewPage } from '@/pages/audit-logs/audit-log-detail-view-page.tsx';

export const Route = createFileRoute('/_auth/audit-logs/$auditLogId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { auditLogId: auditLogIdParam } = useParams({
    from: '/_auth/audit-logs/$auditLogId',
  });

  const auditLogId = Number(auditLogIdParam);
  if (!Number.isFinite(auditLogId)) {
    return <div>Ungültige AuditLogId: {auditLogIdParam}</div>;
  }

  return <AuditLogDetailViewPage auditLogId={auditLogId} />;
}
